import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tip",
  "use": "icon-tip-usage",
  "viewBox": "0 0 70 70",
  "content": "<symbol viewBox=\"0 0 70 70\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tip\">\n<g id=\"icon-tip_&#229;&#143;&#185;&#229;&#143;&#183;\">\n<circle id=\"icon-tip_Ellipse 1\" cx=\"35\" cy=\"35\" r=\"33\" fill=\"none\" stroke-width=\"4\" />\n<g id=\"icon-tip_Group 3669\">\n<rect id=\"icon-tip_Rectangle 2\" x=\"33\" y=\"14\" width=\"4\" height=\"32\" rx=\"2\" />\n<circle id=\"icon-tip_Ellipse 2\" cx=\"35\" cy=\"52\" r=\"2\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol